<template>
  <div>
    <div class="anchor" :class="customClass" @click="handleClickToGenerateLink">{{ readableName() }}</div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "S3FileGenerator",
  props: [
    "document",
    "customClass"
  ],
  data() {
    return {
      temporaryLinkUri: ""
    }
  },
  methods: {
    ...mapActions('s3ServiceModule', [
      'fetchFile'
    ]),

    async handleClickToGenerateLink() {
      try {
        const s3Data = await this.fetchFile(this.document);
        if (s3Data && s3Data.hasOwnProperty('status') && s3Data.status === 200) {
          this.temporaryLinkUri = s3Data.data.data.url;
          window.open(this.temporaryLinkUri, "_blank");
        } else {

        }
      }
      catch (e) {

        }
    },

    readableName() {
      if (!this.document) {
        return;
      }
      const newName = this.document.split("/").pop();
      return newName.split("-").splice(1, newName.split('-').length).join("-");
    }
  }
}
</script>

<style scoped>
.anchor {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 24px;
  color: #00cfff;
  cursor: pointer;
}
/*.anchor:hover {*/
/*  color: #001d84;*/
/*}*/
</style>
